// 🔧 Utilitário para Variáveis de Ambiente - Vite
// Centraliza o acesso às variáveis de ambiente com validação

interface EnvConfig {
  DEV_SERVER_PORT: number;
  API_URL: string;
  API_TIMEOUT: number;
  SOCKET_URL: string;
  APP_NAME: string;
  APP_VERSION: string;
  APP_DESCRIPTION: string;
  NODE_ENV: string;
  DEBUG: boolean;
  GOOGLE_ANALYTICS_ID?: string;
  SENTRY_DSN?: string;
  ENABLE_NOTIFICATIONS: boolean;
  ENABLE_ANALYTICS: boolean;
}

// Função para converter string para boolean
const toBool = (value: string | undefined): boolean => {
  return value?.toLowerCase() === 'true';
};

// Função para converter string para number
const toNumber = (value: string | undefined, defaultValue: number): number => {
  const num = parseInt(value || '', 10);
  return isNaN(num) ? defaultValue : num;
};

// Configuração das variáveis de ambiente
export const env: EnvConfig = {
  DEV_SERVER_PORT: toNumber(import.meta.env.VITE_DEV_SERVER_PORT, 3000),
  API_URL: import.meta.env.VITE_API_URL || 'http://localhost:3001',
  API_TIMEOUT: toNumber(import.meta.env.VITE_API_TIMEOUT, 120000),
  SOCKET_URL: import.meta.env.VITE_SOCKET_URL || 'http://localhost:3001',
  APP_NAME: import.meta.env.VITE_APP_NAME || 'SysUp',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
  APP_DESCRIPTION: import.meta.env.VITE_APP_DESCRIPTION || 'Sistema de Gerenciamento ISP',
  NODE_ENV: import.meta.env.VITE_NODE_ENV || 'development',
  DEBUG: toBool(import.meta.env.VITE_DEBUG),
  GOOGLE_ANALYTICS_ID: import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  ENABLE_NOTIFICATIONS: toBool(import.meta.env.VITE_ENABLE_NOTIFICATIONS),
  ENABLE_ANALYTICS: toBool(import.meta.env.VITE_ENABLE_ANALYTICS),
};

// Função para log das variáveis (apenas em desenvolvimento)
export const logEnvVars = (): void => {
  if (env.DEBUG) {
    console.group('🔧 Variáveis de Ambiente (Vite)');
    console.log('DEV_SERVER_PORT:', env.DEV_SERVER_PORT);
    console.log('API_URL:', env.API_URL);
    console.log('API_TIMEOUT:', env.API_TIMEOUT);
    console.log('SOCKET_URL:', env.SOCKET_URL);
    console.log('APP_NAME:', env.APP_NAME);
    console.log('APP_VERSION:', env.APP_VERSION);
    console.log('NODE_ENV:', env.NODE_ENV);
    console.log('DEBUG:', env.DEBUG);
    console.log('ENABLE_NOTIFICATIONS:', env.ENABLE_NOTIFICATIONS);
    console.log('ENABLE_ANALYTICS:', env.ENABLE_ANALYTICS);
    console.groupEnd();
  }
};

// Validação das variáveis obrigatórias
export const validateEnv = (): boolean => {
  const required = ['API_URL', 'SOCKET_URL', 'APP_NAME'];
  const missing = required.filter(key => !env[key as keyof EnvConfig]);

  if (missing.length > 0) {
    console.error('❌ Variáveis de ambiente obrigatórias ausentes:', missing);
    return false;
  }

  return true;
};

export default env;